export enum EUserRole {
  SITE_ADMIN = 'ADMIN',
  NORMAL = 'NORMAL',
  LIMITED = 'LIMITED',
  OWNER = 'OWNER',
  ACCOUNT_ADMIN = 'ACCOUNT_ADMIN',
}
